var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c(
        "div",
        [
          _c("div", {
            staticStyle: { height: "480px", width: "600px" },
            attrs: { id: "blocklyDiv" }
          }),
          _vm._v(" "),
          _c(
            "xml",
            {
              staticStyle: { display: "none" },
              attrs: {
                xmlns: "https://developers.google.com/blockly/xml",
                id: "toolbox"
              }
            },
            [
              _c("block", { attrs: { type: "controls_if" } }),
              _vm._v(" "),
              _c("block", { attrs: { type: "logic_compare" } }),
              _vm._v(" "),
              _c("block", { attrs: { type: "controls_repeat_ext" } }),
              _vm._v(" "),
              _c(
                "block",
                { attrs: { type: "math_number" } },
                [_c("field", { attrs: { name: "NUM" } }, [_vm._v("123")])],
                1
              ),
              _vm._v(" "),
              _c("block", { attrs: { type: "math_arithmetic" } }),
              _vm._v(" "),
              _c("block", { attrs: { type: "text" } }),
              _vm._v(" "),
              _c("block", { attrs: { type: "text_print" } })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-054b9c73", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-054b9c73","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo.vue
// module id = null
// module chunks = 